// extracted by mini-css-extract-plugin
module.exports = {"productSpecs":"ProductSpecs_productSpecs__SmjwB"};